import { render, staticRenderFns } from "./MultiplePrizeWinning.vue?vue&type=template&id=7d01be36&scoped=true"
import script from "./MultiplePrizeWinning.vue?vue&type=script&lang=js"
export * from "./MultiplePrizeWinning.vue?vue&type=script&lang=js"
import style0 from "./MultiplePrizeWinning.vue?vue&type=style&index=0&id=7d01be36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d01be36",
  null
  
)

export default component.exports